import { render, staticRenderFns } from "./purchaseCheques.vue?vue&type=template&id=106192d0&"
import script from "./purchaseCheques.vue?vue&type=script&lang=js&"
export * from "./purchaseCheques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports